import {JOIN_HISTORY_RESPONSE} from '../actions/joinHistory.actions';

export default function joinHistory(state = null, action) {
  switch (action.type) {
    case JOIN_HISTORY_RESPONSE: {
      let nextState = action.result;
      return nextState;
    }
  }
  return state;
}
